import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

function pageNumbers(current: number, pages: number): (number | 'ellipsis')[] {
  if (pages <= 7) return Array.from({ length: pages }, (_, index) => index + 1);
  const nearStart = current <= 3 ? [2, 3] : [];
  const nearEnd = current >= pages - 2 ? [pages - 1, pages - 2] : [];
  const numbers = [...new Set([1, pages, ...nearStart, ...nearEnd, current - 1, current, current + 1])]
    .filter(n => n >= 1 && n <= pages).sort((a, b) => a - b);
  return numbers.flatMap((n, index) => index && n !== numbers[index - 1]! + 1 ? ['ellipsis' as const, n] : [n]);
}

/** The numbered pager shared by every list page. `compact` keeps the arrows icon-only in the narrow queue column. */
export function Pager({ page, pages, onPage, label = 'pages', compact = false }:
  { page: number; pages: number; onPage: (page: number) => void; label?: string; compact?: boolean }) {
  if (pages <= 1) return null;
  return <nav className="desk-pager" aria-label={label}>
    <Button variant="ghost" size="sm" onClick={() => onPage(page - 1)} disabled={page <= 1} aria-label="Previous page">
      <ChevronLeft aria-hidden />{compact ? null : 'Previous'}</Button>
    <div className="desk-pager-pages">
      {pageNumbers(page, pages).map((number, index) => number === 'ellipsis'
        ? <span key={`ellipsis-${index}`} className="desk-pager-ellipsis" aria-hidden>…</span>
        : <Button key={number} variant={number === page ? 'default' : 'ghost'} size="sm" aria-label={`Page ${number}`}
          aria-current={number === page ? 'page' : undefined} onClick={() => onPage(number)}>{number}</Button>)}
    </div>
    <Button variant="ghost" size="sm" onClick={() => onPage(page + 1)} disabled={page >= pages} aria-label="Next page">
      {compact ? null : 'Next'}<ChevronRight aria-hidden /></Button>
  </nav>;
}
